import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ArticleService } from 'src/app/services/article.services';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { OrderService } from 'src/app/services/order.service';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { UserService } from 'src/app/services/user.service';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'app-accountorders',
  templateUrl: './accountorders.component.html',
  styleUrls: ['./accountorders.component.css']
})
export class AccountordersComponent implements OnInit {
cartItems: any[] = [];
 wishlistCount: number = 0;
  cartCount: number = 0;
  isModalOpen: boolean = false;
  isCancelModalOpen: boolean = false;
  orders: any[] = [];
  selectedOrder: any = null;
  events: any[] = [];
  userInfo: any = {};
  userId: number = 2;
  isTimelineModalOpen: boolean = false;
  scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/nouislider.min.js',
    'assets/js/shop.js',
    'assets/js/main.js'

  ];
  isLoggedIn = false;
  constructor(
    private orderService: OrderService,
    private scriptLoader: ScriptLoaderService,
    private articleservice: ArticleService,
    private authService: AuthServiceService,
    private userService: UserService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private cartService: CartService ,private wishlist : WishlistService,
  ) {

  }

  ngOnInit(): void {
    this.scriptLoader.loadScripts(this.scripts);
      this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });
     this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
    const clientId = this.authService.getClientId();
    const guestOrderId = localStorage.getItem('guestOrderId');

    if (clientId) {
        this.loadOrders(clientId); // Chargement normal pour les clients connectés
    } else if (guestOrderId) {
        console.warn("🔹 Mode invité : récupération de la commande", guestOrderId);
       // this.loadGuestOrder(guestOrderId); // Chargement pour les invités
    } else {
        console.error('⚠️ Aucune commande trouvée pour cet utilisateur.');
    }

  }
  loadOrders(clientId: number): void {
    this.orderService.getOrdersByClientId(clientId).subscribe(
      (data: any[]) => {
        this.orders = data;
        console.log('Commandes récupérées :', data);
      },
      (error: any) => {
        console.error('Erreur lors de la récupération des commandes :', error);
      }
    );
  }
   goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  getEtatById(statusId: number): any {
    const etats = [
      { id: 2, libelle: "Confirmé", code_couleur: "#008000", icone: "bi-check-circle" },
      { id: 1, libelle: "En attente", code_couleur: "#ffa500", icone: "bi-clock" },
      { id: 3, libelle: "Annulé", code_couleur: "#ff0000", icone: "bi-x-circle" },
      { id: 4, libelle: "Chez livreur", code_couleur: "#0000ff", icone: "bi-truck" },
      { id: 6, libelle: "Retour non reçu", code_couleur: "#ffa500", icone: "bi-arrow-right-circle" },
      { id: 5, libelle: "Reporté", code_couleur: "#696969", icone: "bi-arrow-repeat" },
      { id: 8, libelle: "Payée", code_couleur: "#0000ff", icone: "bi-cash-coin" },
      { id: 7, libelle: "Retour reçu", code_couleur: "#008000", icone: "bi-arrow-left-circle" }
    ];

    return etats.find(etat => etat.id === statusId) || { libelle: "Inconnu", code_couleur: "#000000", icone: "bi-question" };
  }
  logout() {
    this.authService.logout();
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('clientId'); // Supprime également le client ID
    this.isLoggedIn = false;
    this.router.navigate(['/home']); // Redirige vers la page d'accueil
  }  order: any;
  getNombreTotalArticles(order: any): number {
    if (!order || !order.lignes_commande) return 0;
    return order.lignes_commande.reduce(
      (total: number, ligne: any) => total + ligne.nbr_article,
      0
    );
  }

}
